// services.config.ts
// import { HomeOutlined, SunOutlined, BankOutlined } from "@ant-design/icons";
import {
  HomeOutlined,
  SunOutlined,
  EnvironmentOutlined,
  ClockCircleOutlined,
  MoonOutlined,
} from "@ant-design/icons";

interface IService {
   key: string,
    title: string,
    description: string,
    icon: React.ElementType,
    location: string,
    theme: {
      bg: string
      color: string
    },
}

interface ServiceColor {
   [key: string]: {bg: string; color: string}
}

export const DogBoardingIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
    <path
      d="M3 11L12 4l9 7v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8z"
      fill="#FFE8D6"
      stroke="#F97316"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="14" r="2.5" fill="#FDBA74" />
  </svg>
);

export const DoggyDayCareIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="4" fill="#FDE68A" stroke="#F59E0B" strokeWidth="1.6" />
    <path
      d="M12 2v3M12 19v3M2 12h3M19 12h3"
      stroke="#F59E0B"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const HomeVisitIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 11L12 5l8 6v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8z"
      fill="#ECFEFF"
      stroke="#06B6D4"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M12 13v3M12 13h2"
      stroke="#0891B2"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

export const HouseSittingIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
    <path
      d="M5 11L12 6l7 5v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7z"
      fill="#EEF2FF"
      stroke="#6366F1"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M16 4a4 4 0 1 0 0 8 5 5 0 0 1 0-8z"
      fill="#C7D2FE"
    />
  </svg>
);

export const DogWalkingIcon = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
    <path
      d="M6 14l3-3 4 1 3-2 2 3"
      stroke="#3B82F6"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="6" cy="16" r="1.6" fill="#93C5FD" />
    <circle cx="15" cy="17" r="1.6" fill="#60A5FA" />
  </svg>
);

export const SERVICE_COLORS = {
  dog_boarding: {
    bg: "#FFF7ED",   // orange-50
    color: "#F97316" // orange-500
  },
  doggy_day_care: {
    bg: "#FFFBEB",   // yellow-50
    color: "#F59E0B" // yellow-500
  },
  dog_walking: {
    bg: "#EFF6FF",   // blue-50
    color: "#3B82F6" // blue-500
  },
  home_visit: {
    bg: "#ECFEFF",   // cyan-50
    color: "#06B6D4" // cyan-500
  },
  house_sitting: {
    bg: "#EEF2FF",   // indigo-50
    color: "#6366F1" // indigo-500
  },
} as ServiceColor;

export const SERVICES = [
  {
    key: "dog_boarding",
    title: "Dog Boarding",
    description: "24h stay at your home",
    icon: HomeOutlined,
    location: "sitter_home",
    theme: SERVICE_COLORS.dog_boarding,
  },
  {
    key: "doggy_day_care",
    title: "Doggy Day Care",
    description: "Daytime care at your home",
    icon: SunOutlined,
    location: "sitter_home",
    theme: SERVICE_COLORS.doggy_day_care,
  },
  {
    key: "dog_walking",
    title: "Dog Walking",
    description: "Min. 30-minute walks",
    icon: EnvironmentOutlined,
    location: "owner_home",
    theme: SERVICE_COLORS.dog_walking,
  },
  {
    key: "home_visit",
    title: "One home visit a day",
    description: "Min. 30-minute visit",
    icon: ClockCircleOutlined,
    location: "owner_home",
    theme: SERVICE_COLORS.home_visit,
  },
  {
    key: "house_sitting",
    title: "House Sitting",
    description: "24h stay at the owner's home",
    icon: MoonOutlined,
    location: "owner_home",
    theme: SERVICE_COLORS.house_sitting,
  },
] as IService[];
